import "./App.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  useNavigate,
} from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "bootstrap/dist/js/bootstrap.min.js";
// import { Carousel } from 'bootstrap/dist/js/bootstrap.min.js';
import "bootstrap-icons/font/bootstrap-icons.css";
import HomeCarousel from "./Components/home/HomeCarousel";
import Navbar from "./Components/nav/Navbar";
import ShopByCategory from "./Components/category/ShopByCategory";
import MinNavbar from "./Components/nav/MinNavbar";
import ProductCard from "./Components/Product/ProductCard";
import Home from "./Components/Product/Home";
import Bgimg from "./Components/bgfix/Bgimg";
import Contact from "./Components/footer/Contact";
import Footer from "./Components/footer/Footer";
import bg from "./Components/images/f2d-bg.png";
import Featurebanner from "./Components/feature/Featurebanner";
import DailyProd from "./Components/dailyprod/DailyProd";
import { SearchProvider } from "./Components/SearchContext";
import ScrollToTop from "./Components/ScrollToTop";
import { useEffect } from "react";
import Bgimgs from "./Components/bgfix/Bgimgs";

function App() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to home if user refreshes any page other than "/"
    if (location.pathname !== "/") {
      navigate("/", { replace: true });
    }
  }, []);

  return (
    <>
      <ScrollToTop />
      <div>
        <SearchProvider>
          {/* Sticky nav container */}
          <div className="sticky-header">
            <Navbar />
          </div>

          {/* Your routes */}
          <HomeCarousel/>
          {/* <Routes>
            <Route path="" element={<HomeCarousel />} />
          </Routes> */}

          {/* Main content area */}
          <div style={{ background: `url(${bg})` }}>
            <Home />
            <Featurebanner />
            <Bgimgs/>
            {/* <Bgimg /> */}
            <DailyProd />
            <Contact />
            <Footer />
          </div>
        </SearchProvider>
      </div>
    </>
  );
}

export default App;
